import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

export const useUserTracking = () => {
  const posthog = usePostHog();

  useEffect(() => {
    if (posthog) {
      // These will be added to ALL events automatically
      posthog.register({
        system: 'admin-ui',
      });
    }
  }, [posthog]);

  const trackEvent = (eventName: string, properties?: Record<string, unknown>) => {
    if (posthog) {
      posthog.capture(eventName, properties);
    }
  };

  const identifyUser = (userId: string, properties?: Record<string, unknown>) => {
    if (posthog) {
      posthog.identify(userId, properties);
    }
  };

  const captureException = (error: unknown, properties?: Record<string, unknown>) => {
    if (posthog) {
      posthog.captureException(error, properties);
    }
  };

  return {
    trackEvent,
    identifyUser,
    captureException,
  };
};
